import { Controller } from "@hotwired/stimulus"

// Hero conversation panel with multiple outcome scenarios (book a call,
// capture the lead, deliver the link, …). Tabs switch scenarios; each switch
// replays the thread animation by re-applying .thread-run (see the CSS —
// without JS the threads render fully visible and static).
//
// Auto-advance: cycles scenarios every few seconds until the visitor picks a
// tab themselves. Disabled entirely under prefers-reduced-motion.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { interval: { type: Number, default: 7000 } }

  connect() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.index = 0
    this.show(0)
    if (!this.reducedMotion && this.panelTargets.length > 1) this.startCycle()
  }

  disconnect() {
    this.stopCycle()
  }

  select(event) {
    // A deliberate choice stops the attract loop.
    this.stopCycle()
    this.show(this.tabTargets.indexOf(event.currentTarget))
  }

  show(index) {
    if (index < 0 || index >= this.panelTargets.length) return
    this.index = index

    this.tabTargets.forEach((tab, i) => {
      const active = i === index
      tab.setAttribute("aria-selected", active)
      tab.classList.toggle("hero-tab-active", active)
    })

    this.panelTargets.forEach((panel, i) => {
      const active = i === index
      panel.hidden = !active
      panel.classList.remove("thread-run")
      if (active && !this.reducedMotion) {
        void panel.offsetWidth // reflow so re-adding the class replays the animation
        panel.classList.add("thread-run")
      }
    })
  }

  startCycle() {
    this.stopCycle()
    this.timer = setInterval(() => {
      this.show((this.index + 1) % this.panelTargets.length)
    }, this.intervalValue)
  }

  stopCycle() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
}
